import React, { useEffect, useState } from 'react';
import metrics from '../internetMetrics';
import { Modal } from "react-bootstrap";
import { Accordion } from 'react-bootstrap';
import DayRange from '../DayRange';
import __ from '../internetLanguage';


export default function TaxonomyFiltersModal({filters, counts, checkedFilters, onFilterChange, form, totalResults, activeTab, isSpanish }) {
	const [showAll, setShowAll] = useState({});
	const [show, setShow] = useState(false);
	const [pendingFilters, setPendingFilters] = useState({});
	const [pendingDateRange, setPendingDateRange] = useState(null);
	const [applyDateRangeMethod, setApplyDateRangeMethod] = useState(null);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);


	// Sync initial state when modal opens
	useEffect(() => {
		if (show) {
			setPendingFilters(JSON.parse(JSON.stringify(checkedFilters)));
		}
	}, [show]);

	const toggleShowAll = (filterName) => {
		setShowAll((prev) => ({...prev, [filterName]: !prev[filterName] }));
	};
	const clearAll = () => {
		setPendingFilters({});
		setPendingDateRange('0'); // Reset date range to "All dates"
	};
	const applyAll = () => {
		// Apply date range changes first
		if (applyDateRangeMethod) {
			applyDateRangeMethod();
		}

		// Compare checkedFilters vs pendingFilters to apply changes
		Object.keys(filters).forEach((filterName) => {
			const original = checkedFilters[filterName] || [];
			const updated = pendingFilters[filterName] || [];

			const toAdd = updated.filter((val) => !original.includes(val));
			const toRemove = original.filter((val) => !updated.includes(val));

			toAdd.forEach((option) => onFilterChange(filterName, option, true));
			toRemove.forEach((option) => onFilterChange(filterName, option, false));
		});

		handleClose();
	};



	const handlePendingCheckboxChange = (filterName, option, isChecked) => {
		metrics.event(null, `cdcsitesearch-filter-${filterName}`);
		setPendingFilters((prev) => {
			const updated = { ...prev };
			updated[filterName] = updated[filterName] || [];

			if (isChecked) {
				if (!updated[filterName].includes(option)) {
					updated[filterName].push(option);
				}
			} else {
				updated[filterName] = updated[filterName].filter((val) => val !== option);
			}
			return updated;
		});
	};

	const handleKeyPress = (e, filterName, option) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			const isChecked = checkedFilters[filterName]?.includes(option) || false;
			handlePendingCheckboxChange(filterName, option, !isChecked);
		}
	};

	// Handlers for DayRange pending changes
	const handlePendingDateRangeChange = (dateRange) => {
		setPendingDateRange(dateRange);
	};

	const handleRegisterApplyMethod = (applyMethod) => {
		setApplyDateRangeMethod(() => applyMethod);
	};

	const renderCheckboxFilter = (filterName, options, index) => {
		if (!filters || filters[filterName].length < 1) {
			return ''; // If no options, render nothing
		}
		const showAllOptions = showAll[filterName];
		const checkedOptions = options.filter(option => checkedFilters[filterName].includes(option));
		const uncheckedOptions = options.filter(option => !checkedFilters[filterName].includes(option));

		const sortedOptions = [...checkedOptions, ...uncheckedOptions];

		const visibleOptions = showAllOptions ? sortedOptions : sortedOptions.slice(0, 10);

		return (
			<Accordion.Item eventKey={index.toString()} key={`accordion-${filterName}`}>
				<div className='search-filters-header-container'>
					<Accordion.Header className="search-filters-header-title">{filterName}</Accordion.Header>
				</div>
				<Accordion.Body>
					<div className="search-filters-taxonomy-list-container">
						{visibleOptions.map((option) => (
							<div key={option} className="search-filters__input">
								<input
									type="checkbox"
									id={`${filterName}-${option}`}
									className="search-filters-option"
									checked={(pendingFilters[filterName] || []).includes(option)}
									onChange={(e) => handlePendingCheckboxChange(filterName, option, e.target.checked)}
									onKeyDown={(e) => handleKeyPress(e, filterName, option)}
								/>
								<label htmlFor={`${filterName}-${option}`} className="search-filters-label">
									{option}{' '}
								</label>
								<span className="search-filters__count">
									({counts[filterName]?.[option] || 0})
								</span>
							</div>
						))}
					</div>

					{options.length > 10 && (
						<button className={`${showAllOptions ? 'search-filters-show-button--active' : ''} search-filters-show-button`} onClick={() => toggleShowAll(filterName)}>
							{showAllOptions ? 'Show Less ' : 'Show More '} <i className={`cdc-fa-angle-${showAllOptions ? 'up' : 'down'}`}></i>
						</button>
					)}
				</Accordion.Body>
			</Accordion.Item>
		);
	};


	const showFilterButton = isSpanish ||
	                         (filters && Object.keys(filters).length > 0) ||
	                         (checkedFilters && Object.keys(checkedFilters).some(key =>
	                             checkedFilters[key] && checkedFilters[key].length > 0));


	return (
		<>
			{ showFilterButton && (
				<button onClick={handleShow} className="search-filters-modal-trigger">
					{__('filter')} <span className="cdc-fa-sliders-simple"></span>
				</button>
			)}
			<Modal show={show} onHide={handleClose} dialogClassName="search-filters-modal">
				<Modal.Header>
					<h3 className="search-filters-modal-title">{__('filter')}</h3>
					<button onClick={handleClose} className="search-filters-modal-close-button">
						<span className="cdc-fa-circle-xmark"></span>
					</button>
				</Modal.Header>
				<Modal.Body>
					<DayRange
						form={form}
						id="mobile-dates"
						totalResults={ !isSpanish ? totalResults : {web: 1}}
						activeTab={!isSpanish ? activeTab : 'web'}
						onPendingDateRangeChange={handlePendingDateRangeChange}
						onRegisterApplyMethod={handleRegisterApplyMethod}
					/>
						{ activeTab === 'web' && !isSpanish && (
							<Accordion
								alwaysOpen
								defaultActiveKey={["0"]}
								key={Object.keys(filters).join(',')}
								className="search-filters"
							>
								{Object.keys(filters).map((filterName, filterBlockId) => {
									return renderCheckboxFilter(filterName, filters[filterName], filterBlockId);
								})}
							</Accordion>
						)}
				</Modal.Body>
				<Modal.Footer>
					<div className="search-filters-modal-footer button-container">
						<button className="clear-button" onClick={clearAll}>Clear All</button>
						<button className="apply-button apply-button--primary" onClick={applyAll}>
							Apply
						</button>
					</div>
				</Modal.Footer>
			</Modal>
		</>
	);
}
